var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIconContanct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 65,
    fill: "#118CE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.834 95.0429L67.2354 92.337C69.9602 89.2164 72.4111 86.2556 74.5917 83.4394L76.3918 81.0647C83.908 70.9378 87.668 62.9002 87.668 56.9596C87.668 44.2791 77.446 34 64.834 34C52.222 34 42 44.2791 42 56.9596C42 62.9002 45.76 70.9378 53.2762 81.0647L55.0763 83.4394C58.1872 87.4254 61.4419 91.2933 64.834 95.0429Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8335 66.3482C70.088 66.3482 74.3477 62.0885 74.3477 56.834C74.3477 51.5795 70.088 47.3198 64.8335 47.3198C59.579 47.3198 55.3193 51.5795 55.3193 56.834C55.3193 62.0885 59.579 66.3482 64.8335 66.3482Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconContanct);
export default __webpack_public_path__ + "static/media/location_icon-contanct.ddd3552ed75a68b17e27eaaaa8ae38d6.svg";
export { ForwardRef as ReactComponent };